(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["almica-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCountdown = (countdown) => {
      if (countdown.dataset.initialized === 'true') return;

      const targetTime = Date.parse(countdown.dataset.target);
      if (Number.isNaN(targetTime)) return;

      countdown.dataset.initialized = 'true';

      const timer = countdown.querySelector('[data-countdown-display]');
      const note = countdown.querySelector('[data-release-note]');
      const after = countdown.querySelector('[data-countdown-after]');
      const status = countdown.querySelector('[data-countdown-status]');
      const daysNode = countdown.querySelector('[data-days]');
      const hoursNode = countdown.querySelector('[data-hours]');
      const minutesNode = countdown.querySelector('[data-minutes]');
      const secondsNode = countdown.querySelector('[data-seconds]');
      let intervalId;
      let lastAnnouncedMinute = -1;

      const pad = (value) => String(value).padStart(2, '0');

      const update = () => {
        const remaining = Math.max(0, targetTime - Date.now());

        if (remaining === 0) {
          timer.hidden = true;
          if (note) note.hidden = true;
          after.hidden = false;
          status.textContent = countdown.dataset.afterMessage;
          if (intervalId) window.clearInterval(intervalId);
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        daysNode.textContent = pad(days);
        hoursNode.textContent = pad(hours);
        minutesNode.textContent = pad(minutes);
        secondsNode.textContent = pad(seconds);

        const totalMinutes = Math.floor(totalSeconds / 60);
        if (totalMinutes !== lastAnnouncedMinute) {
          status.textContent = `${days} days, ${hours} hours and ${minutes} minutes until launch.`;
          lastAnnouncedMinute = totalMinutes;
        }
      };

      update();
      intervalId = window.setInterval(update, 1000);
    };

    const initializeAllCountdowns = (scope = document) => {
      scope.querySelectorAll('[data-almica-countdown]').forEach(initializeCountdown);
    };

    initializeAllCountdowns();

    if (!window.almicaCountdownSectionListener) {
      document.addEventListener('shopify:section:load', (event) => initializeAllCountdowns(event.target));
      window.almicaCountdownSectionListener = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
